module['exports'] = [
  'ایشیایْ شیر',
  'مشرقی افریقی شیر',
  'شمالی مغربی کانگو کا شیر',
];
